import React, { useEffect, useState } from "react";
import CommonAccountPanelView from "presentational/account/CommonAccountPanelView";
import LoadingModalView from "presentational/common/modals/LoadingModalView";
import TXT from "presentational/common/multinational/TXT";
import { isValidInput } from "lib/textFilter";
import { useHistory } from "react-router-dom";
import { withStore } from "store/storeHandler";
import { withToken } from "lib/forceTokenRenewComponent";
import { getEssentialUrl } from "lib/urlQueryParser";
import Service from "lib/service-amp";

function RootChangePassword(props) {
  const { tokenAuthType, AppErrorActions, NoticeModalActions } = props;
  const { forceRenewTokenWT } = props;
  const [passwordForAuth, setPasswordForAuth] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const history = useHistory();

  useEffect(() => {
    checkEmailAuthUser();
  }, []);

  const checkEmailAuthUser = async () => {
    if (tokenAuthType !== "cognito_email") {
      history.replace(getEssentialUrl({ type: "opening" })());
    }
  };

  const goToPreviousURL = () => {
    history.goBack();
  };

  const handleTextChange = (type, value) => {
    switch (type) {
      case "passwordForAuth":
        setPasswordForAuth(value);
        break;
      case "newPassword":
        setNewPassword(value);
        break;
      case "confirmNewPassword":
        setConfirmNewPassword(value);
        break;
      default:
        AppErrorActions.setSafeAppError(Error(`wrong type => type:"${type}"`));
        break;
    }
  };

  const handleSubmitBtnClick = async () => {
    if (!passwordForAuth) {
      displayNotice("oldPwNotFound");
      return null;
    } else if (!newPassword || !confirmNewPassword) {
      displayNotice("newPwNotFound");
      return null;
    } else if (!isValidInput("password", newPassword.trim())) {
      displayNotice("incorrectPwFormat");
      return null;
    } else if (newPassword !== confirmNewPassword) {
      displayNotice("twoNewPwNotMatch");
      return null;
    } else if (passwordForAuth === newPassword) {
      displayNotice("sameNewPwAsOldOne");
      return null;
    }

    await setIsLoading(true);

    const hasSucceed = await forceRenewTokenWT();
    if (!hasSucceed) return null;

    const { code, res } = await Service.changePassword(
      passwordForAuth.trim(),
      newPassword.trim()
    );
    switch (code) {
      case "ok":
        displayNotice("success", goToPreviousURL);
        break;
      case "NotAuthorizedException":
        displayNotice("oldPwNotAuthorized");
        setIsLoading(false);
        break;
      case "LimitExceededException":
        displayNotice("limitExceeded");
        setIsLoading(false);
        break;
      case "error":
      default:
        AppErrorActions.setSafeAppError(Error(res));
        displayNotice("defaultError");
        setIsLoading(false);
        break;
    }
  };

  const handleCancelBtnClick = () => {
    goToPreviousURL();
  };

  const displayNotice = (type, callback) => {
    let content;
    switch (type) {
      case "success":
        content = <TXT name="msg_passwordChanged" />;
        break;
      case "oldPwNotFound":
        content = <TXT name="msg_enterPassword" />;
        break;
      case "newPwNotFound":
        content = <TXT name="msg_enterNewPassword" />;
        break;
      case "twoNewPwNotMatch":
        content = <TXT name="msg_matchBothPassword" />;
        break;
      case "oldPwNotAuthorized":
        content = <TXT name="msg_wrongCurrentPassword" />;
        break;
      case "sameNewPwAsOldOne":
        content = <TXT name="msg_newPasswordMustNew" />;
        break;
      case "limitExceeded":
        content = <TXT name="msg_passwordChangeRequestExceeded" />;
        break;
      case "incorrectPwFormat":
        content = <TXT name="msg_pwFormatGuide" />;
        break;
      case "defaultError":
      default:
        content = <TXT name="msg_commonNetworkError" />;
        break;
    }
    NoticeModalActions.openModal({ content, callback });
  };

  return (
    <div>
      <CommonAccountPanelView
        title={<TXT name="titlePanel_changePassword" />}
        textElement={["passwordForAuth", "newPassword", "confirmNewPassword"]}
        onInputValueChange={handleTextChange}
        firstBtnText={<TXT name="btnPanel_changePassword" />}
        onFirstBtnClick={handleSubmitBtnClick}
        modeToggleBtnText={<TXT name="btnPanelToggle_cancel" />}
        onModeToggleBtnClick={handleCancelBtnClick}
      />
      <LoadingModalView open={isLoading} />
    </div>
  );
}

export default withStore({
  stateMap: { cognitoAuth: ["tokenAuthType"] },
  dispatchMap: ["appError", "noticeModal"]
})(withToken(RootChangePassword));
